import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Feature } from './feature.model';

export class FeatureStateModel extends EntityStateModel<Feature> {}
